import { render, staticRenderFns } from "./TestAccessPoints.vue?vue&type=template&id=2421cce9"
import script from "./TestAccessPoints.vue?vue&type=script&lang=js"
export * from "./TestAccessPoints.vue?vue&type=script&lang=js"
import style0 from "./TestAccessPoints.vue?vue&type=style&index=0&id=2421cce9&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports